import { Reveal, Eyebrow } from "@/components/Motion";

const CHAPTERS = [
    {
        num: "01",
        title: "The water writes the script",
        body: "Every river keeps a diary — hatches, flows, light angles, lies. We teach you to read it before you ever make a cast, because the angler who observes first, catches first.",
    },
    {
        num: "02",
        title: "One language, three dialects",
        body: "Dry, nymph, and streamer are dialects of the same language. Master the dead drift and the slow swing alike, and there is no stretch of trout water that can keep its secrets from you.",
    },
    {
        num: "03",
        title: "Preparation is the edge",
        body: "The difference between a story and a skunking is a packed kit and a plan. Our field-tested checklists turn chaos into ritual — every leader, every fly, every time.",
    },
    {
        num: "04",
        title: "Gear that earns its place",
        body: "We fish everything we recommend. No filler, no fifty-item roundups — just the rods, reels, lines, and flies that have proven themselves in cold water and hard current.",
    },
];

export default function ManifestoChapters() {
    return (
        <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-36" data-testid="manifesto-section">
            <Reveal>
                <Eyebrow>The Trout Start Manifesto</Eyebrow>
                <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-100 max-w-3xl">
                    Four convictions, earned the slow way — one river at a time.
                </h2>
            </Reveal>

            <div className="mt-16 grid md:grid-cols-2 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
                {CHAPTERS.map((c, i) => (
                    <Reveal key={c.num} delay={i * 0.08} className="bg-[#111C2E]">
                        <div className="group relative h-full p-8 sm:p-12 overflow-hidden hover:bg-[#1A273D] transition-colors duration-500">
                            <div className="absolute -top-10 -right-6 w-48 h-48 rounded-full bg-teal-glow blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                            <span className="font-serif text-6xl sm:text-8xl font-light text-teal/15 group-hover:text-teal/30 transition-colors duration-500 select-none">
                                {c.num}
                            </span>
                            <h3 className="relative mt-4 font-sans text-xl sm:text-2xl font-medium text-slate-100">{c.title}</h3>
                            <p className="relative mt-4 font-body text-base leading-relaxed text-slate-400">{c.body}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
